/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';

/**
 * 
 * @export
 * @interface BusinessUnitOverviewDtoSortingRequestDto
 */
export interface BusinessUnitOverviewDtoSortingRequestDto {
    /**
     * Sortable fields for BusinessUnitOverviewDto: name, totalOrderCount, totalOrderAmount, totalOrderAmount, description
     * @type {BusinessUnitOverviewDtoSortingRequestDtoSortByEnum}
     * @memberof BusinessUnitOverviewDtoSortingRequestDto
     */
    sortBy?: BusinessUnitOverviewDtoSortingRequestDtoSortByEnum | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof BusinessUnitOverviewDtoSortingRequestDto
     */
    sortDir?: SortDirection;
}


/**
 * @export
 */
export const BusinessUnitOverviewDtoSortingRequestDtoSortByEnum = {
    name: 'name',
    totalOrderCount: 'totalOrderCount',
    totalOrderAmount: 'totalOrderAmount',
    totalOrderAmount2: 'totalOrderAmount',
    description: 'description'
} as const;
export type BusinessUnitOverviewDtoSortingRequestDtoSortByEnum = typeof BusinessUnitOverviewDtoSortingRequestDtoSortByEnum[keyof typeof BusinessUnitOverviewDtoSortingRequestDtoSortByEnum];


/**
 * Check if a given object implements the BusinessUnitOverviewDtoSortingRequestDto interface.
 */
export function instanceOfBusinessUnitOverviewDtoSortingRequestDto(value: object): value is BusinessUnitOverviewDtoSortingRequestDto {
    return true;
}

export function BusinessUnitOverviewDtoSortingRequestDtoFromJSON(json: any): BusinessUnitOverviewDtoSortingRequestDto {
    return BusinessUnitOverviewDtoSortingRequestDtoFromJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitOverviewDtoSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function BusinessUnitOverviewDtoSortingRequestDtoToJSON(json: any): BusinessUnitOverviewDtoSortingRequestDto {
    return BusinessUnitOverviewDtoSortingRequestDtoToJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoSortingRequestDtoToJSONTyped(value?: BusinessUnitOverviewDtoSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': value['sortBy'],
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

